import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const EquipmentDashboard = lazyLoader(
  () => import("Containers/Equipment/EquipmentDashboard/EquipmentDashboard")
);

export const EquipmentDashboardPage = () => {
  return (
    <Layout>
      <EquipmentDashboard />
    </Layout>
  );
};
